<template>
  <WarRoomBanner>
    <template #header>Your War Room Profile</template>
    <div class="war-room-profile-banner__content">
      <HeaderAnonymousProfile
        :current-user="currentUser"
        :is-loading="$apollo.queries.currentUser.loading"
        :has-war-room-profile="hasWarRoomProfile"
      />
    </div>
    <template #footer>
      <div v-if="hasWarRoomProfile" class="war-room-profile-banner__footer">
        <div>
          <BravadoText variant="body-semibold" class="war-room-profile-banner__footer-item-title">
            {{ currentUser.postsCount }}
          </BravadoText>
          <BravadoText variant="caption1" class="war-room-profile-banner__footer-item-description">Posts</BravadoText>
        </div>
        <div>
          <BravadoText variant="body-semibold" class="war-room-profile-banner__footer-item-title">
            {{ currentUser.commentsCount }}
          </BravadoText>
          <BravadoText variant="caption1" class="war-room-profile-banner__footer-item-description">
            Comments
          </BravadoText>
        </div>
        <div>
          <HeaderCommissionBalance />
          <BravadoText variant="caption1" class="war-room-profile-banner__footer-item-description">
            Commission
          </BravadoText>
        </div>
      </div>
    </template>
  </WarRoomBanner>
</template>

<script lang="ts">
import { defineComponent } from '@nuxtjs/composition-api';

import WarRoomBanner from '@/components/partials/war-room/WarRoomBanner/WarRoomBanner.vue';
import HeaderAnonymousProfile from '@/components/global/HeaderMenu/HeaderAnonymousProfile/HeaderAnonymousProfile.vue';
import HeaderCommissionBalance from '@/components/global/Header/HeaderCommissionBalance/HeaderCommissionBalance.vue';
import BravadoText from '@/components/common/BravadoText/BravadoText.vue';
import CurrentUserQuery from '@/components/partials/war-room/WarRoomProfileBanner/apollo/currentUser.query';
import type { CurrentUser } from '@/types/graphql';

export default defineComponent({
  name: 'WarRoomProfileBanner',
  components: {
    WarRoomBanner,
    HeaderAnonymousProfile,
    HeaderCommissionBalance,
    BravadoText,
  },
  apollo: {
    currentUser: {
      query: CurrentUserQuery,
      skip() {
        return !this.$auth.loggedIn;
      },
    },
  },
  data(): { currentUser: CurrentUser | null } {
    return {
      currentUser: null,
    };
  },
  computed: {
    hasWarRoomProfile(): boolean {
      return !!this.currentUser?.username;
    },
  },
  mounted() {
    this.$apollo.queries.currentUser?.refetch();
  },
});
</script>

<style scoped lang="scss">
.war-room-profile-banner {
  &__content {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  &__footer {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    padding: 0 12px;
  }

  &__footer-item {
    display: flex;
    flex-direction: column;
  }

  &__footer-item-description {
    color: #797b86;
  }

  &__footer-item-title {
    color: var(--theme-color-text);
  }
}
</style>
